import { BarChart } from '../BarChart/BarChart';
import { SyncWithDrillDown } from '../SyncWithDrillDown/SyncWithDrillDown';
import { SwitchingCharts } from '../SwitchingCharts/SwitchingCharts';
import { CustomizableComponent } from '../CustomizableComponent/CustomizableComponent';
import { RichTooltip } from '../RichTooltip/RichTooltip';
import { Annotation } from '../Annotation/Annotation';
import { LargeVolumeDataPointChart } from '../LargeVolumeDataPointChart/LargeVolumeDataPointChart';
import { CombinedBarAndLine } from '../CombinedBarAndLine/CombinedBarAndLine';
import { MultiAxisLine } from '../MultiAxisLine/MultiAxisLine';
import { ZoomLine } from '../ZoomLine/ZoomLine';
import { DrillDown } from '../DrillDown/DrillDown';
import { StockChart } from '../StockChart/StockChart';

const ChartsDisplayLayout = () => {
    return (
        <div className="container mx-auto">
            <h1 className="text-center mt-5">amCharts capability</h1>
            <h2 className="mt-10 mb-2">Combined Bar and Line charts.</h2>
            <p className="mb-4">Ability to render lines on top of bars to show dimmensions like averages, trends or other independent measures from the data source</p>
            <CombinedBarAndLine />
            <h2 className="mt-10 mb-2">Multi-Axis</h2>
            <p className="mb-4">Most solutions show 2, but we have examples with 3 axis.</p>
            <MultiAxisLine />
            <h2 className="mt-10 mb-4">Zoom In/Out</h2>
            <SyncWithDrillDown />
           <h2 className="mt-10 mb-2">Cross Filter</h2>
            <p className="mb-4">Ability to have selections made on one chart, be automatically reflected on other charts in the same page. Usually right below the main chart.</p>
            <DrillDown />
            <h2 className="mt-10 mb-2">Brush Selection</h2>
            <p className="mb-4">Ability to make selections on the chart with an interactive element on the chart itself.</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Mini Map</h2>
            <p className="mb-4">This is a separate visualization usually right below the chart the shows the entire data set zoomed out. Interacting with it allows to pan/move to specific sections of the data on the main chart. Need to be able to customize the location and size of the mini map based on Spark guidelines.</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Custom Notes and Annotations</h2>
            <p className="mb-4">Ability to interactively (by user input) add notes/annotations to data points on the chart. The notes can be simple text when it's user entered. When it's information coming from the data set, it can be HTML with more rich notes.</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Drawing on chart</h2>
            <p className="mb-4">Ability to draw a line/circle on a section of a chart to highlight a particular event. This is for potentially saving the chart to share with someone within the application itself.</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Custom Tooltips</h2>
            <p className="mb-4">Tooltips show on hover and can also be more than just text, but rather rich HTML content like lists, images/icons, etc.</p>
            <RichTooltip />
            <h2 className="mt-10 mb-2">Full visual customization (colors, rounded borders, lines, etc)</h2>
            <p className="mb-4">We have an Enterprise Design System that sets colors and shapes for our visualiations. We need to be able to fully customize the look and feel of the charts.</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Drill Down</h2>
            <p className="mb-4"></p>
            <DrillDown />
            <h2 className="mt-10 mb-2">Live switching of graph type</h2>
            <p className="mb-4">Ability to switch chart types directly on chart, using the same data source (visualize same data in different ways).</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Reference Lines</h2>
            <p className="mb-4">Render threshold and references line at arbitrary points based on data type (top/bottom/middle points, etc.).</p>
            <StockChart />
            <h2 className="mt-10 mb-2">Draggable Curves</h2>
            <h2 className="mt-10 mb-2 text-red-500">Time Slider</h2>
            <p className="mb-4">Ability to render chart values on a timed interval or as user moves across X axis, so they can see value move over time.</p>
            
            <h2 className="mt-10 mb-2 text-red-500">Performance</h2>
            <p className="mb-4">
                Ability to load/render large volume of data points. (Refer Highcharts
                <a className="hover:underline text-blue-400 pointer" href="https://www.highcharts.com/docs/advanced-chart-features/boost-module" target="_blank"> Boost module.</a>)
            </p>
        </div>
    )
}

export { ChartsDisplayLayout }